/*
 * @LastEditTime: 2020-06-17 19:08:36
 * @LastEditors: jinxiaojian
 */

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Base from './Input';
import TextAreaWithMax from './TextareaWithMax';
import { useControlledInputs } from '../../common/hooks';
import { nfn } from '../../common';
import { omit } from 'lodash';

function Input(props, ref) {
  const { defaultValue, onChange, type, max, ...others } = props;
  const { value, handleChange } = useControlledInputs({
    defaultValue,
    onChange,
    mapDefaultToValue: v => v,
    mapValuetoValue: v => v
  });

  if (type === 'textarea' && max) {
    return (
      <TextAreaWithMax
        type={type}
        max={max}
        defaultValue={defaultValue}
        onChange={onChange}
        ref={ref}
        {...omit(others, ['isSearch', 'background'])}
      />
    );
  } else {
    return (
      <Base
        type={type}
        value={value}
        handleChange={handleChange}
        {...others}
        ref={ref}
      />
    );
  }
}

export default forwardRef(Input);

Input.defaultProps = {
  type: 'text',
  defaultValue: '',
  isSearch: false,
  mini: false,
  radius: true,
  background: true,
  onChange: nfn
};

Input.propTypes = {
  /** 输入内容改变时的回调 */
  onChange: PropTypes.func,
  /** 渲染眼睛图标 */
  showEye: PropTypes.bool,
  /** 默认值 */
  defaultValue: PropTypes.string,
  /** 小size的 */
  mini: PropTypes.bool,
  /** 是否圆角 */
  radius: PropTypes.bool,
  /** 是否深色背景 */
  background: PropTypes.bool,
  /** 是否显示搜索图标 */
  isSearch: PropTypes.bool,
  /** 是否可清除 */
  clearable: PropTypes.bool,
  /** 主动修改组件值时候的值， @see controled input */
  value: PropTypes.string,
  /** 类型 */
  type: PropTypes.oneOf(['text', 'textarea', 'password']),
  /** 是否Error, 自带error样式 */
  hasError: PropTypes.bool,
  /** 当type为textarea时，设置max,则会显示当前输入的字数 */
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** 提示语句 */
  placeholder: PropTypes.string
};
